import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { MedSwitchGroupComponent } from "./med-switch-group.component";
import { MedSwitchModule } from "../med-switch/med-switch.module";

@NgModule({
  declarations: [
    MedSwitchGroupComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedSwitchModule,
  ],
  exports: [
    MedSwitchGroupComponent,
  ],
})
export class MedSwitchGroupModule { }
